// extracted by mini-css-extract-plugin
module.exports = {"status":"oderCard_status__e5CKk","circle":"oderCard_circle__CckdP"};